import { render, staticRenderFns } from "./redZoneList.vue?vue&type=template&id=64a10d84&"
import script from "./redZoneList.vue?vue&type=script&lang=js&"
export * from "./redZoneList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports